import * as _ from "../../../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../../../wayin-react";
import { PrivateInput as Input } from "../../../../core/input";
var SharingInput = createComponent({
  displayName: 'SharingInput',
  defaultProps: {
    onChange: _.noop(),
    required: false,
    hasError: false
  },
  propTypes: {
    onChange: PropTypes.func,
    required: PropTypes.bool,
    hasError: PropTypes.bool
  },
  handlers: {
    onFieldChanged: function onFieldChanged(p) {
      return function (e, _ref) {
        var value = _ref.value;
        p.setHasError(p.required && !value || p.maxChars && value.length > p.maxChars);
        p.onChange(e, {
          value: value
        }, p);
      };
    }
  },
  state: {
    hasError: {
      value: function value(p) {
        return p.hasError;
      },
      updater: 'setHasError'
    }
  },
  lifecycles: {
    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
      return this.props.value !== nextProps.value;
    }
  },
  render: function render(p) {
    return /*#__PURE__*/React.createElement(Input, {
      name: p.name,
      value: p.value,
      onChange: p.onFieldChanged,
      maxChars: p.maxChars,
      placeholder: p.placeholder,
      required: p.required,
      hasError: p.hasError
    });
  }
});
export default SharingInput;
//# sourceMappingURL=input.js.map